var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zj-homeview-root select-none"},[_c('div',{staticClass:"nav-section"},[_c('div',{staticClass:"content-wrapper"},[_c('NavViewFastTrackEntrance')],1),_c('div',{staticClass:"content-wrapper"},[_c('NavViewMessageCenter')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }